import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const percentageNotNegative = (schema: yup.StringSchema) =>
  schema.test('not-negative', 'Percentual não pode ser negativo', (value) => {
    if (!value) return true
    const numValue = Number(value.replace(',', '.'))
    return !isNaN(numValue) && numValue >= 0
  })

export const distributeBillingModalSchema = yupResolver(
  yup.object({
    invoiceDays: yup.string().when('distributionType', {
      is: false,
      then: (schema) =>
        schema
          .required('Qtd de dias é obrigatório')
          .test('max-days', 'Qtd de dias não pode ser maior que 31', (value) => {
            if (!value) return false
            const numValue = Number(value)
            return !isNaN(numValue) && numValue <= 31
          }),
      otherwise: (schema) => schema
    }),
    weekdays: yup.string().when('distributionType', {
      is: false,
      then: (schema) => percentageNotNegative(schema.required('Segunda a Sexta-feira é obrigatório')),
      otherwise: (schema) => schema
    }),
    saturday: yup.string().when('distributionType', {
      is: false,
      then: (schema) => percentageNotNegative(schema),
      otherwise: (schema) => schema
    }),
    sunday: yup.string().when('distributionType', {
      is: false,
      then: (schema) => percentageNotNegative(schema),
      otherwise: (schema) => schema
    }),
    holidays: yup
      .array()
      .of(
        yup.object({
          date: yup
            .string()
            .transform((value) => value?.trim() || '')
            .required('Data do feriado é obrigatória')
        })
      )
      .optional()
  })
)
